import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './LanguageToggle.css';

/**
 * Header KO / EN language switch.
 * Navigates to the same path under the other language prefix.
 */
export function LanguageToggle() {
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('common');

  const currentLang = lang === 'en' ? 'en' : 'ko';
  const otherLang: 'ko' | 'en' = currentLang === 'ko' ? 'en' : 'ko';

  const switchLanguage = () => {
    // Replace the lang prefix in the pathname and keep the rest
    const newPath = location.pathname.replace(
      /^\/(ko|en)(\/|$)/,
      `/${otherLang}$2`
    );
    navigate(newPath + location.search + location.hash, { replace: false });
  };

  return (
    <button
      className="language-toggle"
      onClick={switchLanguage}
      aria-label={t('language.toggle')}
      title={t('language.toggle')}
    >
      <span className={`language-toggle-option ${currentLang === 'ko' ? 'is-active' : ''}`}>
        KO
      </span>
      <span className="language-toggle-sep" aria-hidden="true">/</span>
      <span className={`language-toggle-option ${currentLang === 'en' ? 'is-active' : ''}`}>
        EN
      </span>
    </button>
  );
}
